import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Tag from "@amzn/meridian/tag"
import Column from "@amzn/meridian/column"
import ControlGroup from "@amzn/meridian/control-group"
import {getFeaturesFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {FormattedMessage, injectIntl} from "react-intl";
import {chainWalk, getDisplayName, parseCapabilitiesResponse} from "../util/Util";
import {ConfigContext} from "../global/context/ConfigContext";
import {ACTION_TYPE, CAPABILITY, FEATURES} from "../util/Constants";
import {InductFilterContext} from "./context/InductFilterContext";
import Checkbox from "@amzn/meridian/checkbox";
import Link from "@amzn/meridian/link";
import Box from "@amzn/meridian/box";
import {MobileDisplay} from "../common/MobileDisplay";
import {FilterExpander} from "../common/FilterExpander";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const InductFilter = ({ intl }) => {
    const {filter, dispatch} = useContext(InductFilterContext)
    const {configDispatch, configViewModel} = useContext(ConfigContext);
    const {isMobile} = useDeviceLayout();
    const formattedIdPrefix = "induct."

    const getCycleName = (cycleId) => {
        if(cycleId === "NONE") {
            return getDisplayName("Unplanned", formattedIdPrefix);
        }
        return cycleId;
    }

    const isCycleFilterSet = () => {
        return filter.selectedCycles.length > 0
    }

    const clearAllCycleFilters = () => {
        dispatch({type: 'CLEAR_ALL_CYCLE'});
    }

    const removeCycle = (cycleId) => {
        dispatch({type: 'CLEAR_CYCLE', data: {cycleId: cycleId}});
    }

    const getCPTLabel = (label) => {
        if(label === "NONE") {
            return getDisplayName("Unplanned", formattedIdPrefix);
        }
        return label;
    }

    const isCPTFilterSet = () => {
        return filter.selectedCPT.length > 0
    }

    const clearAllCPTFilters = () => {
        dispatch({type: 'CLEAR_ALL_CPT'});
    }

    const removeCPT = (CPT) => {
        dispatch({type: 'CLEAR_CPT', data: {CPT: CPT}});
    }

    useEffect(() => {
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = parseCapabilitiesResponse(capabilityResponse)
            configDispatch({type: 'GET_CAPABILITIES', capability})
            getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatus => {
                configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
                if (isCPTFilterEnabled) {
                    dispatch({type: 'FETCH_CPT', data: {dispatcher: dispatch}})
                } else {
                    dispatch({type: 'FETCH_CYCLE', data: {dispatcher: dispatch}})
                }
            })
        })
    }, []);

    if (CAPABILITY.AR_NEXT_GEN === configViewModel.capability) {
        return null
    }

    const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);
    function displayCPTData(){
        return (
            <Column spacing="small" spacingInset="none none medium none">
                <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                    <ControlGroup
                        label={intl.formatMessage({id:'CPT.'+ filter.CPTLabel})}
                        name="CPT"
                        onChange={(data) => dispatch({type: 'SELECT_CPT', data: {CPT: data}})}
                        value = {filter.selectedCPT}>
                        {filter.allCPT.map(CPT => (
                            <Checkbox key={CPT.id} value={CPT}>{getCPTLabel(CPT.label)}</Checkbox>
                        ))}
                    </ControlGroup>
                </Row>
                <MobileDisplay visibility={false}>
                    <Row width="100%" spacingInset="none">
                        <div className="filter-tag">
                            {filter.selectedCPT.map(CPT => {
                                return <Tag key={CPT.id} type="theme"
                                            onClose={()=>removeCPT(CPT)}>{CPT.label}</Tag>
                            })}
                        </div>
                        {isCPTFilterSet() ? <Link onClick={clearAllCPTFilters} type="secondary">
                            <FormattedMessage id="linehaul_filter.clear_all" defaultMessage="Clear all"/>
                        </Link> : null}
                    </Row>
                </MobileDisplay>
            </Column>
        )
    }

    function displayCycleData(){
        return (
            <Column spacing="small" spacingInset="none none medium none">
                <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                    <ControlGroup
                        label={intl.formatMessage({id:'induct.cycle'})}
                        name="cycles"
                        onChange={(data) => dispatch({type: 'SELECT_CYCLE', data: {cycles: data}})}
                        value = {filter.selectedCycles}>
                        {filter.allCycles.map(cycle => (
                            <Checkbox key={cycle.cycleId} value={cycle.cycleId}>{getCycleName(cycle.cycleId)}</Checkbox>
                        ))}
                    </ControlGroup>
                </Row>
                <MobileDisplay visibility={false}>
                    <Row width="100%" spacingInset="none">
                        <div className="filter-tag">
                            {filter.selectedCycles.map(cycle => {
                                return <Tag key={cycle} type="theme"
                                            onClose={()=>removeCycle(cycle)}>{cycle}</Tag>
                            })}
                        </div>
                        {isCycleFilterSet() ? <Link onClick={clearAllCycleFilters} type="secondary">
                            <FormattedMessage id="linehaul_filter.clear_all" defaultMessage="Clear all"/>
                        </Link> : null}
                    </Row>
                </MobileDisplay>
            </Column>
        )
    }

    function renderFilterOptions() {
        if(isCPTFilterEnabled){
            return displayCPTData();
        }
        else
            return displayCycleData();
    }

    return(
        <Box>
            {isMobile ?
            <FilterExpander>
                {renderFilterOptions()}
            </FilterExpander> : renderFilterOptions()}
        </Box>
    )

}

export default injectIntl(InductFilter);


// WEBPACK FOOTER //
// ./src/components/induct/InductFilter.js